import React, { useState } from 'react';
import { Box, Button, Heading, Layer, TextInput } from 'grommet';
import { Close } from 'grommet-icons';
import PropTypes from 'prop-types';
import JobService from '../../api/job-service';

export const EditJobSeatsModal = ({ job, setShowEditJobSeatsModal }) => {
    const [seats, setSeats] = useState(job.seats || 0);
    const [buttonBusy, setButtonBusy] = useState();

    const editJobSeats = async () => {
        try {
            setButtonBusy(true);
            await new JobService().updateJobSeats(job.id, seats);
            setShowEditJobSeatsModal(false);
            location.reload();
        } catch (error) {
            setButtonBusy(false);
            console.log(error);
        }
    };

    return (
        <Layer
            onClickOutside={() => setShowEditJobSeatsModal(false)}
            onEsc={() => setShowEditJobSeatsModal(false)}
            position="center">
            <Box
                background="white"
                pad="medium"
                round="6px"
                border={{ color: 'enrich-green-light', size: '3px' }}
                alignSelf="center"
                gap="30px">
                <Box direction="row" gap="20px" justify="between">
                    <Heading level="3" margin={{ vertical: 'none' }}>
                        Edit Job Seats
                    </Heading>
                    <Box align="end">
                        <Close
                            onClick={() => {
                                setShowEditJobSeatsModal(false);
                            }}
                            cursor="pointer"
                        />
                    </Box>
                </Box>
                <Box>
                    <Box
                        width="medium"
                        align="center"
                        round="6px"
                        background="white">
                        <TextInput
                            type={'number'}
                            onChange={(event) => setSeats(event.target.value)}
                            placeholder="number of seats"
                            value={seats}
                        />
                    </Box>
                </Box>
                <Box>
                    <Button
                        primary
                        busy={buttonBusy}
                        label="Done"
                        style={{ width: '220px', height: '50px' }}
                        alignSelf="center"
                        onClick={editJobSeats}
                    />
                </Box>
            </Box>
        </Layer>
    );
};

EditJobSeatsModal.propTypes = {
    job: PropTypes.object,
    setShowEditJobSeatsModal: PropTypes.func,
};
